<template>
  <su-page title="个人资料">
    <el-row slot="content">
      <el-row class="commonItem">
        <div class="commonLeftText">账号：</div>
        <div class="commonRightText">{{ userInfo.account }}</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">手机号：</div>
        <div class="commonRightText">{{ userInfo.mobile }}</div>
      </el-row>
      <el-row class="commonItem">
        <div class="commonLeftText">姓名：</div>
        <div class="commonRightText">{{ userInfo.name }}</div>
      </el-row>
    </el-row>
  </su-page>
</template>
<script>


import {getUserInfo} from "@/api/api";

export default {
  name: "personalData",
  data() {
    return {
      userInfo: {}
    }
  },
  mounted() {

  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.status === 200) {
          this.userInfo = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.userCenter {
  &-item {

  }
}
</style>
